if (!customElements.get('rm-quantity-breaks')) {
  customElements.define(
    'rm-quantity-breaks',
    class RMQuantityBreaks extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.disc2 = Number(this.dataset.disc2 || 15);
        this.disc3 = Number(this.dataset.disc3 || 20);
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.unitPrice = Number(this.dataset.price || 0);
        this.comparePrice = Number(this.dataset.compare || 0);

        this.options = Array.from(this.querySelectorAll('.rm-qb__option'));
        this.radios = Array.from(this.querySelectorAll('.rm-qb__radio'));

        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.applySelection());
        });

        this.options.forEach((option) => {
          option.addEventListener('click', (event) => {
            if (event.target.closest('input')) return;
            const radio = option.querySelector('.rm-qb__radio');
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        this.startTimer();
        this.applySelection();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const sectionId = event?.data?.sectionId;
            if (sectionId && sectionId !== this.sectionId) return;
            this.syncPriceFromDom();
            // Re-apply qty after Dawn resets quantity to min on variant change
            requestAnimationFrame(() => this.applySelection());
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribeVariant) this.unsubscribeVariant();
        if (this.timerId) clearInterval(this.timerId);
      }

      syncPriceFromDom() {
        const priceEl = document.querySelector(
          `#price-${this.sectionId} .price__regular .price-item--regular, #price-${this.sectionId} .price-item--sale`
        );
        // Prefer JSON from variant select if available
        const variantInput = document.querySelector(`#product-form-${this.sectionId} input[name="id"], product-form form input[name="id"]`);
        const productJson = document.querySelector(`script[type="application/json"][data-product-json], [data-product]`);
        // Read from selected option data or price dataset updates via section HTML
        const priceWrapper = document.getElementById(`price-${this.sectionId}`);
        if (priceWrapper) {
          const sale = priceWrapper.querySelector('.price-item--sale');
          const regular = priceWrapper.querySelector('.price-item--regular');
          const visible = sale || regular;
          if (visible) {
            const cents = this.parseMoneyToCents(visible.textContent);
            if (cents > 0) this.unitPrice = cents;
          }
          const compare = priceWrapper.querySelector('.price__compare .price-item--regular, s.price-item--regular');
          if (compare) {
            const compareCents = this.parseMoneyToCents(compare.textContent);
            this.comparePrice = compareCents > this.unitPrice ? compareCents : 0;
          } else {
            this.comparePrice = 0;
          }
          this.refreshDisplayedPrices();
        }
        void variantInput;
        void productJson;
      }

      parseMoneyToCents(text) {
        if (!text) return 0;
        const cleaned = String(text).replace(/[^\d.,]/g, '').trim();
        if (!cleaned) return 0;
        // Handle 1,234.56 and 1.234,56
        let normalized = cleaned;
        if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
          if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
            normalized = cleaned.replace(/\./g, '').replace(',', '.');
          } else {
            normalized = cleaned.replace(/,/g, '');
          }
        } else if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') === -1) {
          const parts = cleaned.split(',');
          normalized = parts.length === 2 && parts[1].length <= 2 ? cleaned.replace(',', '.') : cleaned.replace(/,/g, '');
        }
        const value = Number(normalized);
        if (!Number.isFinite(value)) return 0;
        return Math.round(value * 100);
      }

      totalForQty(qty) {
        const p = this.unitPrice;
        if (qty <= 1) return p;
        const percent = qty >= 3 ? this.disc3 : this.disc2;
        return Math.round(p * qty * (1 - percent / 100));
      }

      compareForQty(qty) {
        const base = this.comparePrice > this.unitPrice ? this.comparePrice : this.unitPrice;
        return base * qty;
      }

      formatMoney(cents) {
        const amount = (Number(cents) / 100).toFixed(2);
        const amountNoDecimals = String(Math.round(Number(cents) / 100));
        const amountWithComma = amount.replace('.', ',');
        return this.moneyFormat
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
          .replace(/\{\{\s*amount\s*\}\}/g, amount);
      }

      refreshDisplayedPrices() {
        this.radios.forEach((radio) => {
          const qty = Number(radio.value);
          const total = this.totalForQty(qty);
          const compare = this.compareForQty(qty);
          radio.dataset.total = String(total);
          const option = radio.closest('.rm-qb__option');
          if (!option) return;
          const priceEl = option.querySelector('[data-rm-qb-price]');
          const compareEl = option.querySelector('[data-rm-qb-compare]');
          if (priceEl) priceEl.textContent = this.formatMoney(total);
          if (compareEl) {
            if (compare > total) {
              compareEl.textContent = this.formatMoney(compare);
              compareEl.hidden = false;
              compareEl.classList.remove('rm-qb__compare--empty');
            } else {
              compareEl.hidden = true;
              compareEl.classList.add('rm-qb__compare--empty');
            }
          }
        });
      }

      getQuantityInput() {
        return (
          document.getElementById(`Quantity-${this.sectionId}`) ||
          document.querySelector(`#Quantity-Form-${this.sectionId} .quantity__input`) ||
          document.querySelector('quantity-input .quantity__input')
        );
      }

      applySelection() {
        const selected = this.radios.find((r) => r.checked) || this.radios[0];
        if (!selected) return;
        const qty = Number(selected.value) || 1;

        this.options.forEach((option) => {
          option.classList.toggle('is-selected', option.contains(selected));
        });

        const input = this.getQuantityInput();
        if (input) {
          input.value = String(qty);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
          }
        }
      }

      startTimer() {
        const root = this.querySelector('[data-rm-qb-timer]');
        if (!root) return;
        const hEl = root.querySelector('[data-h]');
        const mEl = root.querySelector('[data-m]');
        const sEl = root.querySelector('[data-s]');

        const tick = () => {
          const now = new Date();
          const end = new Date(now);
          end.setHours(23, 59, 59, 999);
          let diff = Math.max(0, Math.floor((end - now) / 1000));
          const h = String(Math.floor(diff / 3600)).padStart(2, '0');
          diff %= 3600;
          const m = String(Math.floor(diff / 60)).padStart(2, '0');
          const s = String(diff % 60).padStart(2, '0');
          if (hEl) hEl.textContent = h;
          if (mEl) mEl.textContent = m;
          if (sEl) sEl.textContent = s;
        };

        tick();
        this.timerId = setInterval(tick, 1000);
      }
    }
  );
}
